import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getFromLocale, getSiteInfo } from "@/utils";

const { lang, curr, siteName } = getSiteInfo()??{}


export const jobsApi = createApi({
  reducerPath: "jobApis",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.API_URL}/api`,
    prepareHeaders: (headers) => {
      headers.set("Authorization", `Bearer ${getFromLocale()}`);
      headers.set("Accept", "application/json");
      headers.set("Currency", `${curr}`);
      headers.set("Language", `${lang}`);
      headers.set("Referrer", siteName);
      return headers;
    },
  }),
  tagTypes: ["jobs", "postJobApply "],
  endpoints: (builder) => ({
    getJobList: builder.query({
      query: () => "/job",
      providesTags: ["jobs"],
    }),
    getJobDetail: builder.query({
      query: (jobId) => `/job/${jobId}`,
      providesTags: ["jobs"],
    }),
    applyForJob: builder.mutation({
      query: (jobData) => ({
        url: "/job/apply",
        method: "POST",
        body: jobData,
      }),
      invalidatesTags: ["postJobApply"],
    }),
  }),
});

export const {
  useApplyForJobMutation,
  useGetJobListQuery,
  useGetJobDetailQuery,
} = jobsApi;
